import { Link } from "react-router-dom";
import { Repeat } from "lucide-react";
import { cad, day } from "@/components/sponsored/format";
import { useRefundQueue } from "@/components/admin/sponsored/useRefundQueue";

export function RefundQueueCard() {
  const s = useRefundQueue();
  if (!s?.open) return null;
  return (
    <Link to="/admin/sponsored-cashback?tab=refunds" data-testid="admin-refund-queue-card"
      className="mt-6 pf-card p-5 flex flex-wrap items-center gap-4 ring-2 ring-rose-300/70 hover:ring-rose-400 transition-shadow">
      <span className="w-10 h-10 rounded-full bg-rose-600 text-white inline-flex items-center justify-center font-bold tabular-nums" data-testid="admin-refund-queue-count">{s.open}</span>
      <div className="flex-1 min-w-[200px]">
        <div className="font-semibold text-slate-900 flex items-center gap-2"><Repeat className="w-4 h-4" /> Sponsored Cashback refund request{s.open === 1 ? "" : "s"} waiting</div>
        <div className="text-sm text-slate-600" data-testid="admin-refund-queue-detail">{cad(s.total_cad)} waiting for approval · oldest from {day(s.oldest_requested_at)}</div>
      </div>
      <span className="pf-btn-primary px-4 py-2 rounded-full text-sm">Review</span>
    </Link>
  );
}
